module.exports = __webpack_public_path__ + "img/storefront.5866a802.png";